import { render, staticRenderFns } from "./addstore.vue?vue&type=template&id=37fa45e1"
import script from "./addstore.vue?vue&type=script&lang=js"
export * from "./addstore.vue?vue&type=script&lang=js"
import style0 from "./addstore.vue?vue&type=style&index=0&id=37fa45e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports